import { lazy } from 'react';

// project-imports
import DashboardLayout from 'layout/Dashboard';
import Loadable from 'components/Loadable';

// render - other pages
const OtherSamplePage = Loadable(lazy(() => import('views/SamplePage')));
// const ReduxDemoPage = Loadable(lazy(() => import('views/ReduxDemo')));

// ==============================|| OTHER ROUTING ||============================== //

const OtherRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'other',
          children: [
            {
              path: 'sample-page',
              element: <OtherSamplePage />
            }
            // {
            //   path: 'redux-demo',
            //   element: <ReduxDemoPage />
            // }
          ]
        }
      ]
    }
  ]
};

export default OtherRoutes;
